export const style = {
  list: {
    sx: {
      width: '100%',
    },
  },
  card: {
    content: {
      sx: {
        overflow: 'auto',
        px: 2,
        py: 3,
      },
    },
    circular: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    sx: {
      width: 480,
      overflow: 'auto',
      height: 'calc(100% - 80px)',
      borderRadius: 0,
    },
    drawer: {
      flexShrink: 0,
      overflow: 'auto',
      width: 480,
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        zIndex: 2,
        top: 80,
        height: '100%',
        overflow: 'auto',
      },
    },
    header: {
      height: 84,
      backgroundColor: 'primary.main',
      color: '#fff',
      position: 'sticky',
      top: '0',
      zIndex: 2,
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
} as const;
